import useCanOrder from '@/catalog/hooks/use-can-order';
import useHasUnpaidBalance from '@/account/hooks/use-has-unpaid-balance';
import { SubscriptionCFA } from '@/account/types/subscription';

/**
 * Show sales pitch if user has no outstanding balance, can order a vehicle, and there is savings calculator data available.
 *
 * @param unpaidBalance User's unpaid balance
 * @param subscription Account subscription
 * @param savingsCalculatorAvailable Flag indicating if vehicle savings calculator is available for current vehicle
 * @returns True, if sales pitch should be shown; false, otherwise
 */
export default function useShouldShowSalesPitch(
  unpaidBalance?: number,
  subscription?: SubscriptionCFA,
  savingsCalculatorAvailable?: boolean
): boolean {
  const hasOutstandingBalance = useHasUnpaidBalance(unpaidBalance);
  const canOrder = useCanOrder(subscription);
  return !hasOutstandingBalance && canOrder && !!savingsCalculatorAvailable;
}
